// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14Pd8","content":"styles_content__3aSdV"};